import React from "react"
import { translate } from "react-i18next"
import styled from "styled-components"
import ReportRequestTable from "./ReportRequestTable"
import ReportRequestRefreshButton from "./ReportRequestRefreshButton"

const ReportCard = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  padding-top: 1em;
  padding-bottom: 1em;
  color: #455a64;
`
const ReportRequests = ({ t }) => {
  return (
    <ReportCard>
      <div className="container">
        <p>{t("CustomReport.RequestedReport.Intro")}</p>
      </div>
      <ReportRequestRefreshButton />
      <ReportRequestTable />
    </ReportCard>
  )
}

export default translate()(ReportRequests)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReportRequestsTab/ReportRequests.jsx